// @ts-nocheck
import React from 'react';
import { Box, Typography } from '@mui/material';

import { ORDER_STATUS_FLOW_FEATURE, getStatusName, notSoldReasonOptions } from 'utils/constants';
import { renderKr } from 'utils/formatter';

const formatDateTime = value => new Date(value).toLocaleString('da-DK', { dateStyle: 'short', timeStyle: 'short' });
const formatDate = value => new Date(value).toLocaleDateString('da-DK');

const statusFlowOrganisation = { enabledFeatures: [ORDER_STATUS_FLOW_FEATURE] };

const getReasonName = value => notSoldReasonOptions.find(reason => reason.value === value)?.name || value;

export const getStatusChangeDetails = (change) => {
    if (change.status === 'followUp' && change.followUp) {
        const { date, title, advisor, notes } = change.followUp;
        return [
            [title, date && `d. ${formatDate(date)}`, advisor?.name && `ansvarlig: ${advisor.name}`].filter(Boolean).join(' · '),
            notes,
        ].filter(Boolean);
    }
    if (change.status === 'completed' && change.invoice) {
        const { productName, amount, invoiceDate } = change.invoice;
        return [[productName, renderKr(amount), invoiceDate && `fakturadato ${formatDate(invoiceDate)}`].filter(Boolean).join(' · ')];
    }
    if (change.status === 'notSold' && change.notSoldReasons?.length) {
        return [`Årsag: ${change.notSoldReasons.map(getReasonName).join(', ')}`];
    }
    return [];
};

function OrderStatusHistory({ statusHistory = [] }) {
    if (!statusHistory.length) return null;

    const newestFirst = [...statusHistory].sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt));

    return (
        <Box sx={{ my: 3 }}>
            <Typography variant="h5" sx={{ mb: 1 }}>Status-historik</Typography>
            { newestFirst.map(change => (
                <Box key={ change.statusChangeId || change.changedAt } sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}>
                    <Typography variant="body2">
                        <strong>{ getStatusName(change.status, statusFlowOrganisation) }</strong>
                        { ` · ${formatDateTime(change.changedAt)}` }
                        { change.changedBy?.name && ` · ${change.changedBy.name}` }
                    </Typography>
                    { getStatusChangeDetails(change).map(detail => (
                        <Typography key={ detail } variant="body2" color="text.secondary">{ detail }</Typography>
                    )) }
                </Box>
            )) }
        </Box>
    );
}

export default OrderStatusHistory;
